module.exports = __webpack_public_path__ + "img/01.31228c13.png";